import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxSpinnerModule } from "ngx-spinner";
import { SharedModule } from "../shared/shared.module";
import { RouterModule } from "@angular/router";
import { NgxPermissionsModule } from "ngx-permissions";
import { CheckOutComponent } from "./components/check-out/check-out.component";
import { PaymentRoutingModule } from "./payment-routing.module";

@NgModule({
    declarations: [
        CheckOutComponent
    ],
    imports: [
      PaymentRoutingModule,
      CommonModule,
      NgxPermissionsModule.forChild(),
      RouterModule,
      FormsModule,
      SharedModule,
      ReactiveFormsModule,
      NgxSpinnerModule
    ], providers: [
      DatePipe
    ]
  })
  export class PaymentModule { }
  